import React from 'react'
import shareIconBlack from '../../../assets/images/share-black.svg'
import { analyticsEvent } from '../Analytics/AnalyticsEvent'

export default function ShareButton({
  url = window.location.href,
  title = document.title,
  text = 'Unravel Trips!',
  eventName = 'Not Specified',
  category = 'Not Specified',
}) {
  const handleShareButton = async () => {
    // Check if navigator.share is supported by the browser
    const storedTripId = localStorage.getItem('tripId')
    const metaData = localStorage.getItem('metaData')
    if (navigator.share) {
      console.log('Congrats! Your browser supports Web Share API')
      try {
        await navigator
          .share({
            url: `https://trip.unravelapp.com/trip?tripId=${storedTripId}`,
            title: title,
            text: metaData,
          })
          .then(() => {
            console.log('Sharing successfull')
            analyticsEvent.clickEvent(category, eventName)
          })
      } catch (error) {
        console.log(`error:  ${error}`)
      }
    } else {
      alert('Sorry! Your browser does not support Web Share API')
    }
  }
  return (
    <div>
      <img
        onClick={handleShareButton}
        type="button"
        title="Share this Page"
        style={{ cursor: 'pointer' }}
        src={shareIconBlack}
        alt="share-icon"
      ></img>
    </div>
  )
}
